var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blog-item m-b-50"},[_c('BlogItemHeader',{attrs:{"blog":_vm.blog}}),_c('div',{staticClass:"blog-description"},[_c('p',[_vm._v(" "+_vm._s(_vm.blog.text)+" ")]),_c('div',{staticClass:"d-flex justify-content-end"},[_c('router-link',{staticClass:"card-ctx text-primary font-weight-bold l-h-20",attrs:{"to":{
          name: _vm.R_BLOG_DETAILS,
          query: {id: _vm.blog.id}
        }}},[_vm._v(" Continue Reading ")])],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }